export default defineNuxtRouteMiddleware(() => {
    const auth = useAuthStore();
    if (!auth.isLogged) return;

    if (auth.isPicker) return;

    if (auth.isSeller) {
        return navigateTo("/tat/vendedor/Ruta");
    }

    if (auth.isAdmin) {
        return navigateTo("/tat/admin/Dashboard");
    }

    if (auth.isCourier) {
        return navigateTo("/tat/transportista/Pedidos");
    }

    return navigateTo("/");
});
